import i18n from '@/utils/i18n';
import React from 'react';
import { AppPageLayout } from '@experiences/templates/app-page-layout';
import { FINANCE_HUB_ROUTES } from '@/navigators/routes';
import { FinanceHubBreadcrumb } from '@finance-hub/components/finance-hub-breadcrumb';
import { FinanceHubInvoicesStackParams } from '@/navigators/types';
import { FinanceHubShellTemplate } from '@finance-hub/templates/finance-hub-shell-template';
import { InvoicesContent } from '@finance-hub/domain/invoicing/containers/invoices-content';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  FinanceHubInvoicesStackParams,
  typeof FINANCE_HUB_ROUTES.Invoices
>;

export const InvoicesScreen: React.FC<Props> = () => (
  <FinanceHubShellTemplate>
    <AppPageLayout
      leadingActions={
        <FinanceHubBreadcrumb title={i18n.t('finance_hub.invoices.title')} />
      }
      scroll={false}
    >
      <InvoicesContent />
    </AppPageLayout>
  </FinanceHubShellTemplate>
);
